app.service('FilterService', ['$rootScope',
    function ($rootScope) {

        const siteHelper = $rootScope.site_helper;
        const modelConstructor = $rootScope.model_constructor;

        const BasicModel = modelConstructor.BasicModel;
        const ModelChoice = modelConstructor.ModelChoice;

        const FilterModel = modelConstructor.extend(BasicModel, {
            id: "filter",
            name: "filter",

            initialized: false,
            initFilter: initFilter,
            condition_models: {},
            ignore_style_exceptions: {},
            additional_style_site_range_ids: {},
            default_selected_ids: {},
            manufacturing_process_order: [],
            base_style_order: [],
            base_colour_order: [],
            finish_order: []
        });

        this.factory = new modelConstructor.ModelFactory({
            birth: function (values) {
                return new FilterModel(values);
            },
            applyModelVariation: applyModelVariation
        });

        const FilterConditionModel = modelConstructor.extend(BasicModel)

        function applyModelVariation(model) {

            this.super(model);

            const variationIDs = model.variation_ids;

            const methodInputModel = $rootScope.factory.method_input.getModel(variationIDs);
            const methodInputChoiceOrder = methodInputModel.choice_order;
            let sourceMethodInputID = null;
            for (let i = 0; i < methodInputChoiceOrder.length; i++) {
                const choiceID = methodInputChoiceOrder[i];
                if (choiceID !== "filter") {
                    sourceMethodInputID = choiceID;
                    break;
                }
            }
            if (!sourceMethodInputID) {
                return;
            }
            const sourceVariationIDs = siteHelper.simpleCloneObject(variationIDs);
            sourceVariationIDs[methodInputModel.navigation_pointer] = sourceMethodInputID;
            const sourceStateList = $rootScope.navigation_manager.createNavigationModel(null, sourceVariationIDs, true).state_list;
            const sourceModel = sourceStateList[sourceStateList.length - 1].model

            const assemblyModel = $rootScope.factory.assembly.getModel(sourceVariationIDs);

            const browseID = variationIDs.browse_id;
            const componentID = variationIDs.component_id;


            const filterOrder = ['feature', 'express_24', 'm2m', 'manufacturing_process', 'base_style', 'base_colour', 'finish', 'assembly'];
            if (!(browseID === "component" && componentID === "door")) {
                const doorOnly = ['express_24', 'm2m', 'manufacturing_process'];
                for (let i = 0; i < filterOrder.length; i++) {
                    if (doorOnly.includes(filterOrder[i])) {
                        filterOrder.splice(i, 1);
                        i--
                    }
                }
            }

            const cacheLocalServerModel = $rootScope.model.cache_local_server;

            const express24Order = cacheLocalServerModel.express_24_option.choice_order.slice();
            const m2mOrder = cacheLocalServerModel.m2m_option.choice_order.slice();
            const manufacturingProcessOrder = cacheLocalServerModel.manufacturing_process.choice_order.slice();
            const baseStyleOrder = cacheLocalServerModel.base_style.choice_order.slice();
            const baseColourOrder = cacheLocalServerModel.base_colour.choice_order.slice();
            const finishOrder = cacheLocalServerModel.finish_option.choice_order.slice();

            if (browseID === "component" && (componentID !== "door" && componentID !== "door_sloping")) {
                const removeBaseStyleID = ['integrated_handle', 'true_handleless'];
                for (let i = 0; i < baseStyleOrder.length; i++) {
                    if (removeBaseStyleID.includes(baseStyleOrder[i])) {
                        baseStyleOrder.splice(i, 1);
                        i--;
                    }
                }
            }

            let featureName = null;
            let featureChoiceOrder = null;
            let featureChoices = null;
            let featureNavigationPointer = null;

            const sourceModelPointer = sourceModel.navigation_pointer;

            let validFeatureIDs = null;
            if (browseID === "component") {
                if (componentID === "door") {
                    validFeatureIDs = ["door"];
                } else if (componentID === "door_sloping") {
                    validFeatureIDs = ["door_sloping"];
                }
            }

            if (sourceModelPointer === "tile_id" || sourceModelPointer === "door_type_id") {
                featureChoiceOrder = sourceModel.choice_order.slice();
                if (validFeatureIDs && validFeatureIDs.length) {
                    for (let i = 0; i < featureChoiceOrder.length; i++) {
                        if (!validFeatureIDs.includes(featureChoiceOrder[i])) {
                            featureChoiceOrder.splice(i, 1);
                            i--
                        }
                    }
                    if (!featureChoiceOrder.length) {
                        featureChoiceOrder = sourceModel.choice_order.slice();
                    }
                }
                featureChoices = siteHelper.simpleCloneObject(sourceModel.choices);
                for (let key in featureChoices) {
                    if (!featureChoiceOrder.includes(key)) {
                        delete featureChoices[key];
                    }
                }
                featureNavigationPointer = sourceModelPointer;
                if (sourceModelPointer === "door_type_id") {
                    featureName = "Door Type";
                } else if (componentID === "door_sloping") {
                    featureName = "Sloping Door";
                } else if (componentID === "curved") {
                    featureName = "Curved Door";
                } else if (componentID === "frame") {
                    featureName = "Frame";
                } else if (componentID === "panel") {
                    featureName = "Panel";
                } else if (componentID === "stock_panel") {
                    featureName = "Panel";
                } else if (componentID === "plinth") {
                    featureName = "Plinth";
                } else if (componentID === "wrap") {
                    featureName = "Wrap";
                } else if (componentID === "component_accessory") {
                    featureName = "Accessory Type";
                }
            } else {

                filterOrder.splice(filterOrder.indexOf('feature'), 1);
            }


            siteHelper.applyValues(model, {
                source_model: sourceModel,
                assembly_model: assemblyModel,
                filter_order: filterOrder,
                express_24_order: express24Order,
                m2m_order: m2mOrder,
                manufacturing_process_order: manufacturingProcessOrder,
                base_style_order: baseStyleOrder,
                base_colour_order: baseColourOrder,
                finish_order: finishOrder,
                feature_name: featureName,
                feature_choices: featureChoices,
                feature_choice_order: featureChoiceOrder,
                feature_navigation_pointer: featureNavigationPointer
            });
        }

        function initFilter() {
            const model = this.root;

            if (model.initialized) {
                return;
            }

            createCoreModels(model);
            createSimpleModels(model);

            model.initialized = true;

        }


        function createCoreModels(model) {

            const featureChoices = model.feature_choices;
            const variationIDs = siteHelper.simpleCloneObject(model.variation_ids);
            const sourceModel = model.source_model;

            let siteRangeModel = null;
            let styleModel = null;
            let colourModel = null;
            const siteRangeIDs = {};
            const styleChoices = {};
            const colourChoices = {};
            const styleChoiceOrder = {};
            const colourChoiceOrder = {};

            let pathChoices;
            let pathTypeID = null;
            if (featureChoices && siteHelper.keyCount(featureChoices) > 0) {
                pathTypeID = "feature";
                pathChoices = featureChoices
            } else {
                pathChoices = {
                    any: {
                        id: "any"
                    }
                }
            }

            function initPathChoices() {
                for (let pathID in pathChoices) {
                    const pathChoice = pathChoices[pathID];
                    pathChoice.variation_ids = siteHelper.simpleCloneObject(variationIDs);
                    if (pathTypeID === "feature") {
                        pathChoice.variation_ids[sourceModel.navigation_pointer] = pathID;
                        if (pathChoice.state_ids) {
                            for (let key in pathChoice.state_ids) {
                                if (!pathChoice.variation_ids[key]) {
                                    pathChoice.variation_ids[key] = pathChoice.state_ids[key]
                                }
                            }
                        }
                    }

                    pathChoice.site_range = {};
                    pathChoice.style = {};
                    pathChoice.colour = {};
                    pathChoice.style_root_colour_ids = {};
                    pathChoice.root_colour_style_ids = {};
                    pathChoice.is_manufactured = false;
                }
            }

            function collectSiteRange() {

                for (let pathID in pathChoices) {

                    const pathChoice = pathChoices[pathID];

                    const pathSiteRangeModel = $rootScope.factory.site_range.getModel(pathChoice.variation_ids);
                    const siteRangeID = pathChoice.variation_ids.site_range_id;
                    if (siteRangeID) {
                        const siteRange = pathSiteRangeModel.choices[siteRangeID];
                        if (siteRange) {
                            pathChoices[pathID].site_range[siteRange.id] = siteRange;
                        }
                    } else {
                        const pathSiteRangeList = pathSiteRangeModel.choiceList();
                        for (let i = 0; i < pathSiteRangeList.length; i++) {
                            const siteRange = pathSiteRangeList[i];
                            pathChoices[pathID].site_range[siteRange.id] = siteRange;
                        }
                    }
                }

                siteRangeModel = $rootScope.factory.site_range.clonedModel(variationIDs);
                const siteRangeList = siteRangeModel.choiceList();

                const choiceOrder = [];
                const choices = {};
                for (let i = 0; i < siteRangeList.length; i++) {
                    const siteRange = siteRangeList[i];

                    let valid = false;
                    for (let pathID in pathChoices) {
                        if (pathChoices[pathID].site_range[siteRange.id]) {
                            valid = true;
                        }
                    }
                    if (!valid) {
                        continue
                    }
                    siteRangeIDs[siteRange.id] = true;
                    siteRange.colour_list = [];
                    choiceOrder.push(siteRange.id);
                    choices[siteRange.id] = siteRange;
                }
                siteRangeModel.choice_order = choiceOrder;
                siteRangeModel.choices = choices;
            }

            function collectColour() {

                for (let pathID in pathChoices) {

                    const pathChoice = pathChoices[pathID];

                    const siteRangeVariationIDs = siteHelper.simpleCloneObject(pathChoice.variation_ids)

                    let isManufactured = pathChoice.is_manufactured;

                    for (let siteRangeID in pathChoice.site_range) {
                        siteRangeVariationIDs.site_range_id = siteRangeID;
                        const pathColourModel = $rootScope.factory.colour.getModel(siteRangeVariationIDs);
                        if (pathColourModel.colour_expected) {
                            isManufactured = true;
                        }

                        const pathColourList = pathColourModel.choiceList();
                        for (let i = 0; i < pathColourList.length; i++) {
                            const colour = pathColourList[i];
                            pathChoices[pathID].colour[colour.root_colour_id] = colour;
                        }
                    }
                    pathChoice.is_manufactured = isManufactured;

                }

                const siteRangeVariationIDs = siteHelper.simpleCloneObject(variationIDs)
                for (let siteRangeID in siteRangeIDs) {
                    siteRangeVariationIDs.site_range_id = siteRangeID;
                    const pathColourModel = $rootScope.factory.colour.getModel(siteRangeVariationIDs);

                    const pathColourList = pathColourModel.choiceList();
                    colourChoiceOrder[siteRangeID] = [];
                    colourChoices[siteRangeID] = [];
                    for (let i = 0; i < pathColourList.length; i++) {
                        const colour = pathColourList[i];
                        let valid = false;
                        for (let pathID in pathChoices) {
                            if (pathChoices[pathID].colour[colour.root_colour_id]) {
                                valid = true;
                                break;
                            }
                        }
                        if (!valid) {
                            continue
                        }
                        colourChoiceOrder[siteRangeID].push(colour.id);
                        colourChoices[siteRangeID][colour.id] = colour;
                    }

                }
            }

            function collectStyle() {

                for (let pathID in pathChoices) {

                    const pathChoice = pathChoices[pathID];

                    const siteRangeVariationIDs = siteHelper.simpleCloneObject(pathChoice.variation_ids)

                    let isManufactured = pathChoice.is_manufactured;
                    let styleExpected = siteHelper.keyCount(pathChoice.site_range) > 1;

                    pathChoice.overrideStyleName = {};
                    for (let siteRangeID in pathChoice.site_range) {
                        siteRangeVariationIDs.site_range_id = siteRangeID;

                        const pathStyleModel = $rootScope.factory.style.getModel(siteRangeVariationIDs);
                        const pathStyleList = pathStyleModel.choiceList();
                        if (pathStyleModel.style_expected) {
                            styleExpected = true;
                            isManufactured = true;
                        } else {
                            for (let i = 0; i < pathStyleList.length; i++) {
                                const style = pathStyleList[i];
                                pathChoice.overrideStyleName[style.id] = pathChoice.site_range[siteRangeID].name;
                            }
                        }

                        const siteRangeColourChoices = {};
                        for (let rootColourID in pathChoices[pathID].colour) {
                            const colour = pathChoices[pathID].colour[rootColourID];
                            if (colour.site_range_id !== siteRangeID) {
                                continue;
                            }
                            const compareColour = colourChoices[siteRangeID][colour.id];
                            if (compareColour.root_colour_id === rootColourID) {
                                siteRangeColourChoices[colour.id] = colour;
                            }
                        }

                        for (let i = 0; i < pathStyleList.length; i++) {
                            const style = pathStyleList[i];

                            const styleColourExceptions = style.colour_exceptions ? style.colour_exceptions : {};
                            const styleRootColourIDs = {}
                            let haveColours = false;
                            for (let colourID in siteRangeColourChoices) {
                                const colour = siteRangeColourChoices[colourID]
                                if (!styleColourExceptions[colourID]) {
                                    haveColours = true;
                                    styleRootColourIDs[colour.root_colour_id] = true;
                                }
                            }

                            if (!haveColours) {
                                continue;
                            }


                            pathChoices[pathID].style[style.id] = style;
                            pathChoices[pathID].style_root_colour_ids[style.id] = styleRootColourIDs;
                        }
                    }
                    pathChoice.style_expected = styleExpected;
                    pathChoice.is_manufactured = isManufactured;

                }

                const siteRangeVariationIDs = siteHelper.simpleCloneObject(variationIDs)
                for (let siteRangeID in siteRangeIDs) {
                    siteRangeVariationIDs.site_range_id = siteRangeID;
                    const pathStyleModel = $rootScope.factory.style.getModel(siteRangeVariationIDs);

                    const pathStyleList = pathStyleModel.choiceList();
                    styleChoiceOrder[siteRangeID] = [];
                    styleChoices[siteRangeID] = [];
                    for (let i = 0; i < pathStyleList.length; i++) {
                        const style = pathStyleList[i];
                        let valid = false;
                        for (let pathID in pathChoices) {
                            if (pathChoices[pathID].style[style.id]) {
                                valid = true;
                                break;
                            }
                        }
                        if (!valid) {
                            continue
                        }

                        styleChoiceOrder[siteRangeID].push(style.id);
                        styleChoices[siteRangeID][style.id] = style;
                    }
                }

            }

            function applyStyleToColour() {
                let rootColourID;
                for (let pathID in pathChoices) {
                    const inputChoices = pathChoices[pathID];
                    const rootColourStyleIDs = {};
                    for (let styleID in inputChoices.style_root_colour_ids) {
                        for (rootColourID in inputChoices.style_root_colour_ids[styleID]) {
                            if (!rootColourStyleIDs[rootColourID]) {
                                rootColourStyleIDs[rootColourID] = {};
                            }
                            rootColourStyleIDs[rootColourID][styleID] = true;
                        }
                        inputChoices.root_colour_style_ids = rootColourStyleIDs;
                    }
                    for (rootColourID in inputChoices.colour) {
                        if (!inputChoices.root_colour_style_ids[rootColourID]) {
                            delete inputChoices.colour[rootColourID];
                        }
                    }
                }
            }

            function filterUnused() {
                let i, choiceList, choice, choiceID, choiceOrder, choices, siteRangeID;
                const siteRangeIDs = {};
                const styleIDs = {};
                const rootColourIDs = {};

                for (let pathID in pathChoices) {
                    const inputChoices = pathChoices[pathID];
                    for (let styleID in inputChoices.style) {
                        const style = inputChoices.style[styleID];
                        styleIDs[styleID] = true;
                        siteRangeIDs[style.site_range_id] = true;
                    }
                    for (let rootColourID in inputChoices.colour) {
                        const colour = inputChoices.colour[rootColourID];
                        rootColourIDs[rootColourID] = true;
                        siteRangeIDs[colour.site_range_id] = true;
                    }

                    delete inputChoices.site_range;
                    delete inputChoices.style;
                    delete inputChoices.colour;
                }

                choiceList = siteRangeModel.choiceList();
                choiceOrder = [];
                choices = {};
                for (i = 0; i < choiceList.length; i++) {
                    choice = choiceList[i];
                    if (!siteRangeIDs[choice.id]) {
                        continue;
                    }
                    choiceOrder.push(choice.id);
                    choices[choice.id] = choice;
                }

                siteRangeModel.choice_order = choiceOrder;
                siteRangeModel.choices = choices;

                for (siteRangeID in styleChoiceOrder) {
                    const siteRangeStyleChoiceOrder = styleChoiceOrder[siteRangeID];
                    const siteRangeStyleChoices = styleChoices[siteRangeID];

                    choiceOrder = [];
                    choices = {};
                    for (i = 0; i < siteRangeStyleChoiceOrder.length; i++) {
                        choiceID = siteRangeStyleChoiceOrder[i];
                        choice = siteRangeStyleChoices[choiceID];
                        if (!styleIDs[choiceID]) {
                            continue;
                        }
                        choiceOrder.push(choice.id);
                        choices[choice.id] = siteRangeStyleChoices[choiceID];
                    }
                    if (choiceOrder.length === 0) {
                        delete styleChoiceOrder[siteRangeID];
                        delete styleChoices[siteRangeID];
                        continue;
                    }
                    styleChoiceOrder[siteRangeID] = choiceOrder;
                    styleChoices[siteRangeID] = choices;

                }

                for (siteRangeID in colourChoiceOrder) {
                    const siteRangeColourChoiceOrder = colourChoiceOrder[siteRangeID];
                    const siteRangeColourChoices = colourChoices[siteRangeID];

                    choiceOrder = [];
                    choices = {};
                    for (i = 0; i < siteRangeColourChoiceOrder.length; i++) {
                        choiceID = siteRangeColourChoiceOrder[i];
                        choice = siteRangeColourChoices[choiceID];
                        if (!rootColourIDs[choice.root_colour_id]) {
                            continue;
                        }
                        choiceOrder.push(choice.id);
                        choices[choice.id] = choice;
                    }
                    if (choiceOrder.length === 0) {
                        delete colourChoiceOrder[siteRangeID];
                        delete colourChoices[siteRangeID];
                        continue;
                    }
                    colourChoiceOrder[siteRangeID] = choiceOrder;
                    colourChoices[siteRangeID] = choices;

                }
            }

            function createSharedStyleModel() {
                let i;
                const choices = {};
                const choiceOrder = []
                const siteRangeOrder = $rootScope.service.site_range.getSiteRangeIDs();
                for (i = 0; i < siteRangeOrder.length; i++) {
                    const siteRangeID = siteRangeOrder[i];
                    const parentStyleChoices = styleChoices[siteRangeID];
                    const parentStyleChoiceOrder = styleChoiceOrder[siteRangeID];
                    if (parentStyleChoices && parentStyleChoiceOrder) {
                        for (let j = 0; j < parentStyleChoiceOrder.length; j++) {
                            const style = parentStyleChoices[parentStyleChoiceOrder[j]];
                            choices[style.id] = style;
                            choiceOrder.push(style.id)
                        }
                    }
                }
                styleModel = $rootScope.factory.style.clonedModel(variationIDs);
                styleModel.choices = choices;
                styleModel.choice_order = choiceOrder;
            }

            function createSharedColourModel() {
                let i;
                const choices = {};
                const choiceOrder = []
                const siteRangeOrder = $rootScope.service.site_range.getSiteRangeIDs();
                for (i = 0; i < siteRangeOrder.length; i++) {
                    const siteRangeID = siteRangeOrder[i];
                    const parentColourChoices = colourChoices[siteRangeID];
                    const parentColourChoiceOrder = colourChoiceOrder[siteRangeID];
                    if (parentColourChoices && parentColourChoiceOrder) {
                        for (let j = 0; j < parentColourChoiceOrder.length; j++) {
                            const colour = parentColourChoices[parentColourChoiceOrder[j]];
                            choices[colour.root_colour_id] = colour;
                            choiceOrder.push(colour.root_colour_id)
                        }
                    }
                }
                colourModel = $rootScope.factory.colour.clonedModel(variationIDs);
                colourModel.choices = choices;
                colourModel.choice_order = choiceOrder;
            }

            function applySiteRangeColours() {
                const colourList = colourModel.choiceList();
                for (let i = 0; i < colourList.length; i++) {
                    const colour = colourList[i];
                    const siteRangeChoice = colour.site_range_id ? siteRangeModel.choices[colour.site_range_id] : null;
                    if (siteRangeChoice) {
                        siteRangeChoice.colour_list.push(colour);
                    }
                }
            }

            initPathChoices();
            collectSiteRange();
            collectColour();
            collectStyle();
            applyStyleToColour();
            filterUnused();
            createSharedStyleModel();
            createSharedColourModel();
            applySiteRangeColours();

            const featureModel = new FilterConditionModel({
                id: "feature",
                name: model.feature_name ? model.feature_name : "Feature",
                navigation_pointer: model.feature_navigation_pointer
            });

            const assemblyModel = new FilterConditionModel({
                id: "assembly",
                name: "Assembly"
            });

            const featureChoiceOrder = model.feature_choice_order ? model.feature_choice_order : [];


            if (model.filter_order.indexOf("assembly") !== -1 && model.assembly_model.choice_order.length > 1) {
                assemblyModel.choice_order = model.assembly_model.choice_order;
                assemblyModel.choices = siteHelper.cloneChoices(model.assembly_model.choices)
            } else {
                assemblyModel.hidden = true;
            }

            if (pathTypeID === "feature" && model.filter_order.indexOf("feature") !== -1 && featureChoiceOrder.length > 0) {
                featureModel.choices = pathChoices;
                featureModel.choice_order = featureChoiceOrder;
                if (featureChoiceOrder.length === 1) {
                    featureModel.hidden = true;
                }
            } else {
                const primaryPathChoice = siteHelper.firstObjectValue(pathChoices);
                model.style_root_colour_ids = primaryPathChoice.style_root_colour_ids;
                model.root_colour_style_ids = primaryPathChoice.root_colour_style_ids;
                featureModel.hidden = true;
            }

            styleModel.hidden = styleModel.choice_order.length < 2;
            colourModel.hidden = colourModel.choice_order.length < 2;


            model.pathTypeID = pathTypeID;
            model.condition_models.feature = featureModel;
            model.condition_models.assembly = assemblyModel;
            model.condition_models.site_range = siteRangeModel;
            model.condition_models.style = styleModel;
            model.condition_models.colour = colourModel;

        }

        function createSimpleModels(model) {

            function createStyleFilter(modelName, modelID, modelChoiceOrder, parentObjectPointer, config, canSelectAll) {
                let i, choiceID, choice;
                const conditionModel = new FilterConditionModel({
                    id: modelID,
                    name: modelName,
                    is_style_filter: true,
                    hidden: model.filter_order.indexOf(modelID) === -1 || model.condition_models.style.hidden,
                    choices: {},
                    choice_order: []
                });
                model.condition_models[modelID] = conditionModel;

                for (i = 0; i < modelChoiceOrder.length; i++) {
                    choiceID = modelChoiceOrder[i];
                    if (!config[choiceID]) {
                        modelChoiceOrder.splice(i, 1);
                        i--;
                    }
                }
                const styleModel = model.condition_models.style;
                for (let styleID in styleModel.choices) {
                    const style = styleModel.choices[styleID];
                    let anyFound = false;
                    for (choiceID in style[parentObjectPointer]) {
                        let thisFound = false;
                        for (i = 0; i < modelChoiceOrder.length; i++) {
                            const checkID = modelChoiceOrder[i];
                            if (choiceID === checkID) {
                                choice = conditionModel.choices[choiceID];
                                if (!choice) {
                                    choice = new ModelChoice({
                                        id: choiceID,
                                        name: config[choiceID].name,
                                        style_ids: {}
                                    })
                                    conditionModel.choices[choiceID] = choice;
                                }
                                choice.style_ids[styleID] = true;
                                thisFound = true;
                                break;
                            }
                        }
                        if (!thisFound) {
                            delete style[parentObjectPointer][choiceID];
                        }
                        anyFound = anyFound || thisFound;
                    }
                    if (!anyFound && modelChoiceOrder.indexOf("other") !== -1) {
                        choice = conditionModel.choices.other;
                        if (!choice) {
                            choice = new ModelChoice({
                                id: "other",
                                name: config.other.name,
                                style_ids: {}
                            })
                            conditionModel.choices.other = choice;
                        }
                        choice.style_ids[styleID] = true;
                    }
                }
                for (i = 0; i < modelChoiceOrder.length; i++) {
                    choiceID = modelChoiceOrder[i];
                    if (conditionModel.choices[choiceID]) {
                        conditionModel.choice_order.push(choiceID);
                    }
                }
                if (conditionModel.choice_order.length < 2) {
                    conditionModel.hidden = true;
                }
                conditionModel.can_select_all = canSelectAll;
            }

            function createColourFilter(modelName, modelID, modelChoiceOrder, parentObjectPointer, config, canSelectAll) {
                let i, choiceID, choice;
                const conditionModel = new FilterConditionModel({
                    id: modelID,
                    name: modelName,
                    is_colour_filter: true,
                    hidden: model.filter_order.indexOf(modelID) === -1 || model.condition_models.colour.hidden,
                    choices: {},
                    choice_order: []
                });
                model.condition_models[modelID] = conditionModel;

                for (i = 0; i < modelChoiceOrder.length; i++) {
                    choiceID = modelChoiceOrder[i];
                    if (!config[choiceID]) {
                        modelChoiceOrder.splice(i, 1);
                        i--;
                    }
                }
                const colourModel = model.condition_models.colour;
                for (let rootColourID in colourModel.choices) {
                    const colour = colourModel.choices[rootColourID];
                    let anyFound = false;
                    for (choiceID in colour[parentObjectPointer]) {
                        let thisFound = false;
                        for (i = 0; i < modelChoiceOrder.length; i++) {
                            const checkID = modelChoiceOrder[i];
                            if (choiceID === checkID) {
                                choice = conditionModel.choices[choiceID];
                                if (!choice) {
                                    choice = new ModelChoice({
                                        id: choiceID,
                                        name: config[choiceID].name,
                                        root_colour_ids: {}
                                    })
                                    conditionModel.choices[choiceID] = choice;
                                }
                                choice.root_colour_ids[rootColourID] = true;
                                thisFound = true;
                                break;
                            }
                        }
                        if (!thisFound) {
                            delete colour[parentObjectPointer][choiceID];
                        }
                        anyFound = anyFound || thisFound;
                    }
                    if (!anyFound && modelChoiceOrder.indexOf("other") !== -1) {
                        choice = conditionModel.choices.other;
                        if (!choice) {
                            choice = new ModelChoice({
                                id: "other",
                                name: config.other.name,
                                root_colour_ids: {}
                            })
                            conditionModel.choices.other = choice;
                        }
                        choice.root_colour_ids[rootColourID] = true;
                    }
                }
                for (i = 0; i < modelChoiceOrder.length; i++) {
                    choiceID = modelChoiceOrder[i];
                    if (conditionModel.choices[choiceID]) {
                        conditionModel.choice_order.push(choiceID);
                    }
                }
                if (conditionModel.choice_order.length < 2) {
                    conditionModel.hidden = true;
                }
                conditionModel.can_select_all = canSelectAll;
            }


            const styleModel = model.condition_models.style;
            for (let styleID in styleModel.choices) {
                const style = styleModel.choices[styleID];

                style.manufacturing_process_ids = style.manufacturing_process_ids ? siteHelper.simpleCloneObject(style.manufacturing_process_ids) : {};
                style.base_style_ids = style.base_style_ids ? siteHelper.simpleCloneObject(style.base_style_ids) : {};
            }

            const colourModel = model.condition_models.colour;

            for (let rootColourID in colourModel.choices) {
                const colour = colourModel.choices[rootColourID];

                colour.express_24_ids = {
                    express_24_if_no: true
                }
                if (colour.lead_time === 1) {
                    colour.express_24_ids.express_24_if_yes = true
                }
                colour.m2m_ids = {
                    m2m_if_no: true
                };
                if (colour.m2m) {
                    colour.m2m_ids.m2m_if_yes = true
                }

                colour.base_colour_ids = colour.base_colour_ids ? siteHelper.simpleCloneObject(colour.base_colour_ids) : {};
                colour.finish_ids = colour.finish_ids ? siteHelper.simpleCloneObject(colour.finish_ids) : {};
            }


            const cacheLocalServerModel = $rootScope.model.cache_local_server;

            const express24Choices = JSON.parse(JSON.stringify(cacheLocalServerModel.express_24_option.choices));
            const m2mChoices = JSON.parse(JSON.stringify(cacheLocalServerModel.m2m_option.choices));
            const manufacturingProcessChoices = JSON.parse(JSON.stringify(cacheLocalServerModel.manufacturing_process.choices));
            const baseStyleChoices = JSON.parse(JSON.stringify(cacheLocalServerModel.base_style.choices));
            const baseColourChoices = JSON.parse(JSON.stringify(cacheLocalServerModel.base_colour.choices));
            const finishChoices = JSON.parse(JSON.stringify(cacheLocalServerModel.finish_option.choices));

            createStyleFilter("Manufacturing Process", "manufacturing_process", model.manufacturing_process_order, 'manufacturing_process_ids', manufacturingProcessChoices, true);
            createStyleFilter("Base Style", "base_style", model.base_style_order, 'base_style_ids', baseStyleChoices, true);

            createColourFilter("Express 24 Hours", "express_24", model.express_24_order, 'express_24_ids', express24Choices, false);
            createColourFilter("Made to Measure", "m2m", model.m2m_order, 'm2m_ids', m2mChoices, false);
            createColourFilter("Base Colour", "base_colour", model.base_colour_order, 'base_colour_ids', baseColourChoices, true);
            createColourFilter("Finish", "finish", model.finish_order, 'finish_ids', finishChoices, true);

        }

    }]);